import { Navigate, useLocation } from 'react-router'
import type { ReactNode } from 'react'
import { useAuth, type Role } from '../lib/auth'

/**
 * Route guard. This is convenience, not security — every endpoint enforces
 * authorization server-side (implementation/PHASE-019).
 */
export function RequireAuth({ roles, children }: { roles?: Role[]; children: ReactNode }) {
  const { state, hasRole } = useAuth()
  const location = useLocation()

  if (state.status === 'loading') {
    return (
      <div
        className="animate-slide-up grid min-h-dvh place-items-center text-sm text-slate-500"
        role="status"
      >
        Chargement…
      </div>
    )
  }
  if (state.status === 'anonymous') {
    // Preserve the intended destination so login can return the user to it.
    return <Navigate to="/connexion" replace state={{ from: location.pathname }} />
  }
  if (roles && !hasRole(...roles)) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
